import { render, staticRenderFns } from "./CompanyDirectoryRoot.vue?vue&type=template&id=dd527c5c&scoped=true"
import script from "./CompanyDirectoryRoot.vue?vue&type=script&lang=ts"
export * from "./CompanyDirectoryRoot.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDirectoryRoot.vue?vue&type=style&index=0&id=dd527c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd527c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
